import { TCarrierStatus } from 'types'
import { CARRIER_STATUS_ICON_MAP } from 'constants/carriers'

export const setIcon = (status: TCarrierStatus) =>
  CARRIER_STATUS_ICON_MAP[status as keyof typeof CARRIER_STATUS_ICON_MAP]
